

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-form-components/src/add-tax-id/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-page-components/src/value-props/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {

    tag: 'xo-add-tax-id-page',

    template: _template2['default'],

    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;

            this.finish = function () {
                _uiRouter.$state.go('checkout.review');
            };
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_uiRouter.$state;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-tax-id/directive.js
 ** module id = 403
 ** module chunks = 1
 **/